import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DsListRowInterface } from './interfaces/ds-list-row.interface';

@Component({
  selector: 'ds-lib-list',
  templateUrl: './ds-lib-list.component.html',
  styleUrls: ['./ds-lib-list.component.scss'],
})
export class DsLibListComponent {
  /**
   * The list of rows
   */
  @Input() public rows: DsListRowInterface[];

  /**
   * The latest clicked row
   */
  @Input() public clickedRow: DsListRowInterface;

  /**
   * Used to emit the clicked row
   */
  @Output() private clickRow = new EventEmitter<DsListRowInterface>();

  /**
   * Creates an instance of DsLibListComponent.
   */
  constructor() {
    this.rows = [];
    this.clickedRow = null;
  }

  /**
   * Change the clicked row and emit it.
   *
   * @param row The clicked row
   */
  public onClickRow(row: DsListRowInterface): void {
    this.clickedRow = row;
    this.clickRow.emit(row);
  }
}
